import { Link } from "react-router-dom"

const root = "/dashboard"

export const items = [
    { key: "dashboard", icon: <i className='fa-solid fa-gauge-high'></i>, label: <Link to={root}>Dashboard</Link>, },
    {
        key: "applications", icon: <i className='fa-solid fa-user-graduate'></i>, label: "Applications",
        children: [
            { key: "applications-0", icon: <i className='fa-solid fa-user-plus'></i>, label: <Link to={root + "/applications/add"}>Apply Now</Link> },
            { key: "applications-1", icon: <i className='fa-solid fa-users'></i>, label: <Link to={root + "/applications/all"}>All Applications</Link> },
        ],
        allowedroles: ["superAdmin"]
    },
    {
        key: "courses", icon: <i className="fa-solid fa-graduation-cap"></i>, label: "Courses",
        children: [
            { key: "courses-0", icon: <i className='fa-regular fa-square-plus'></i>, label: <Link to={root + "/courses/add"}>Add Course</Link> },
            { key: "courses-1", icon: <i className="fa-solid fa-chalkboard-user"></i>, label: <Link to={root + "/courses/all"}>All Courses</Link> },
        ]
    },
    {
        key: "services", icon: <i className="fa-regular fa-building"></i>, label: "Services",
        children: [
            { key: "services-0", icon: <i className='fa-regular fa-square-plus'></i>, label: <Link to={root + "/services/add"}>Add Services</Link> },
            { key: "services-1", icon: <i className='fa-regular fa-building'></i>, label: <Link to={root + "/services/all"}>All Services</Link> },
        ],
        allowedroles: ["superAdmin"]
    },
    {
        key: "blog", icon: <i className="fa-solid fa-graduation-cap"></i>, label: "Blogs",
        children: [
            { key: "blog-0", icon: <i className='fa-regular fa-square-plus'></i>, label: <Link to={root + "/blogs/add"}>Add Blog</Link> },
            { key: "blog-1", icon: <i className="fa-solid fa-chalkboard-user"></i>, label: <Link to={root + "/blogs/all"}>All Blogs</Link> },
        ]
    },
    {
        key: "fees", icon: <i className="fa-regular fa-money-bill-1"></i>, label: "Fees",
        children: [
            { key: "fees-0", icon: <i className='fa-regular fa-square-plus'></i>, label: <Link to={root + "/fees/add"}>Receive</Link> },
            { key: "fees-1", icon: <i className="fa-solid fa-vault"></i>, label: <Link to={root + "/fees/all"}>Received</Link> },
        ]
    },
    {
        key: "students", icon: <i className='fa-solid fa-user-graduate'></i>, label: "Students",
        children: [
            { key: "students-0", icon: <i className='fa-solid fa-user-plus'></i>, label: <Link to={root + "/students/add"}>Add Student</Link> },
            { key: "students-1", icon: <i className='fa-solid fa-users'></i>, label: <Link to={root + "/students/all"}>All Students</Link> },
        ]
    },
    {
        key: "employee", icon: <i className="fa-solid fa-user-tie"></i>, label: "Employee",
        children: [
            { key: "employee-0", icon: <i className='fa-regular fa-square-plus'></i>, label: <Link to={root + "/employee/add"}>Add Employee</Link> },
            { key: "employee-1", icon: <i className="fa-solid fa-chalkboard-user"></i>, label: <Link to={root + "/employee/all"}>All Employee</Link> },
        ]
    },
    {
        key: "settings", icon: <i className="fa-solid fa-cogs"></i>, label: "Settings",
        children: [
            { key: "settings-0", icon: <i className='fa-solid fa-shield-halved'></i>, label: <Link to={root + "/settings/account"}>Account</Link> },
            { key: "settings-1", icon: <i className="fa-regular fa-id-badge"></i>, label: <Link to={root + "/settings/profile"}>Profile</Link> },
        ]
    },
    {
        key: "website-settings", icon: <i className="fa-solid fa-cogs"></i>, label: "Website Settings", allowedroles: ["superAdmin"],
        children: [
            { key: "website-settings-0", icon: <i className="fa-solid fa-bullhorn"></i>, label: <Link to={root + "/website-settings/announcements/all"}>Announcements</Link> },
            { key: "website-settings-1", icon: <i className="fa-solid fa-bars"></i>, label: <Link to={root + "/website-settings/faqs/all"}>FAQs</Link> },
            { key: "website-settings-2", icon: <i className="fa-regular fa-images"></i>, label: <Link to={root + "/website-settings/albums"}>Gallary</Link> },
            { key: "website-settings-3", icon: <i className="fa-solid fa-users"></i>, label: <Link to={root + "/website-settings/teams/all"}>Teams</Link> },
            { key: "website-settings-4", icon: <i className="fa-regular fa-star"></i>, label: <Link to={root + "/website-settings/testimonials/all"}>Testimonials</Link> },
        ]
    },
    { key: "messages", icon: <i className="fa-solid fa-message"></i>, label: <Link to={root + "/messages/all"}>Messages</Link>, allowedroles: ["superAdmin"] },
    { key: "admin", icon: <i className="fa-solid fa-user"></i>, label: <Link to={root + "/admin/all"}>Admin Management</Link>, allowedroles: ["superAdmin"] },
]